import React from 'react';
import { Form, Spin, Upload, Input, Tooltip, Icon, Select, Row, Col, Button } from 'antd';
import { uploadLogo, uploadBanner,uploadMobileBanner, postTag } from '../../modules/Api';
import { END_POINT } from '../../constants/config';
import history from '../../modules/History';
import SitemapChangeFreqInput from '../../components/SitemapChangeFreqInput.js';
import Editor from 'for-editor'
const EditorToolbar = {
    h1: false,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    img: false,
    link: true,
    code: false,
    preview: true,
    expand: true,
    /* v0.0.9 */
    undo: true,
    redo: true,
    save: false,
    /* v0.2.3 */
    subfield: true,
}

const FormItem = Form.Item;
// const Option = Select.Option;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class EventForm extends React.Component {
    constructor() {
        super();
        this.state = {
            tags: [],
            selectedTags: [],
            eventLogo: null,
            eventBanner: null,
            eventMobileBanner: null,
        }
    }
    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {
        console.log(nextProps.initialData)
        if (nextProps.initialData.logo && this.state.eventLogo === null) {
            this.setState({ eventLogo: nextProps.initialData.logo });
        }
        if (nextProps.initialData.banner && this.state.eventBanner === null) {
            this.setState({ eventBanner: nextProps.initialData.banner });
        }
        if (nextProps.initialData.mobile_banner && this.state.eventMobileBanner === null) {
            this.setState({ eventMobileBanner: nextProps.initialData.mobile_banner });
        }
        if (this.state.selectedTags.length === 0 && nextProps.initialData.tag && nextProps.initialData.tag.length > 0) {
            this.setState({ selectedTags: nextProps.initialData.tag });
        }
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {
                banner: this.state.eventBanner,mobile_banner : this.state.eventMobileBanner, logo: this.state.eventLogo, tag: this.state.selectedTags.map(t => t.key)
            }));
        })
    }
    fetchTag(keyword) {
        if (!(keyword === null || keyword === undefined || keyword === '')) {
            this.setState({ tags: [{ text: keyword, value: keyword }] });
        }
    }
    commitTags(items) {
        this.setState({ tags: [], selectedTags: items });
        items.forEach(t => {
            postTag({ title: t.label }, id => {
                this.setState({
                    selectedTags: this.state.selectedTags.map(d => {
                        return d.label === t.label ? Object.assign({}, d, { key: id }) : d;
                    })
                });
            });
        });
    }
    render() {
        let img = '';
        if (this.state.eventLogo != null) {
            img = <img src={`${this.state.eventLogo.includes('http') ? this.state.eventLogo : END_POINT + this.state.eventLogo}`} style={{ width: '50px', height: '50px', margin: '10px' }} alt="لوگو رویداد" />;
        }
        let banner = '';
        if (this.state.eventBanner != null) {
            banner = <img src={`${this.state.eventBanner.includes('http') ? this.state.eventBanner : END_POINT + this.state.eventBanner}`} style={{ width: '172px', height: '110px', margin: '10px' }} alt="بنر رویداد" />;
        }
        let mobile_banner = '';
        if (this.state.eventMobileBanner != null) {
            mobile_banner = <img src={`${this.state.eventMobileBanner.includes('http') ? this.state.eventMobileBanner : END_POINT + this.state.eventMobileBanner}`} style={{ width: '172px', height: '110px', margin: '10px' }} alt="بنر موبایل رویداد" />;
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={10} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="تگ ها"
                                colon={false}>
                                {getFieldDecorator('tag', {
                                    initialValue: this.props.initialData.tag,
                                    rules: [
                                    ],
                                })(
                                    <Select
                                        mode="multiple"
                                        labelInValue
                                        value={this.state.selectedTags}
                                        placeholder="انتخاب تگ"
                                        notFoundContent={this.state.loading ? <Spin size="small" /> : null}
                                        filterOption={false}
                                        onSearch={this.fetchTag.bind(this)}
                                        onChange={this.commitTags.bind(this)}
                                        style={{ width: '200px' }}>
                                        {this.state.tags.map(d => <Select.Option key={d.value}>{d.text}</Select.Option>)}
                                    </Select>
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="لوگوی‌ رویداد"
                                extra="بهتر است فایل انتخابی مربعی و حداقل عرض ۳۰۰ پیکسل و فرمت jpg باشد."
                                colon={false}>
                                {getFieldDecorator('upload', {
                                    valuePropName: 'fileListLogo',
                                    getValueFromEvent: this.normFileLogo,
                                })(
                                    <Upload
                                        name="logo"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadLogo(f, (src) => { this.setState({ eventLogo: src }) ;console.log("lo"+src)}) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {img}
                                    </Upload>
                                )}
                            </FormItem>


                            <FormItem
                                {...formItemLayout}
                                label="بنر رویداد برای دسکتاپ"
                                extra="بهتر است فایل انتخابی فرمت jpg باشد."
                                colon={false}>
                                {getFieldDecorator('uploadBanner', {
                                    valuePropName: 'fileListBanner',
                                    getValueFromEvent: this.normFileBanner,
                                })(
                                    <Upload
                                        name="banner"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadBanner(f, (src) => { this.setState({ eventBanner: src });console.log("b"+src) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {banner}
                                    </Upload>
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="بنر رویداد برای موبایل"
                                extra=""
                                colon={false}>
                                {getFieldDecorator('uploadMobileBanner', {
                                    valuePropName: 'fileListMobileBanner',
                                    getValueFromEvent: this.normFileMobileBanner,
                                })(
                                    <Upload
                                        name="mobile_banner"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadMobileBanner(f, (src) => { this.setState({ eventMobileBanner: src });console.log("mb : "+src) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        
                                        {mobile_banner}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="نام"
                                colon={false}>
                                {getFieldDecorator('name', {
                                    initialValue: this.props.initialData.name,
                                    rules: [{
                                        required: true, message: 'نام رویداد را وارد نمایید',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="توضیحات(درباره رویداد)"
                                colon={false}>
                                {getFieldDecorator('content', {
                                    initialValue: this.props.initialData.content,
                                    rules: [{
                                        required: true, message: 'توضیحات رویداد را وارد نمایید!',
                                    }],
                                })(
                                    <Editor placeholder="توضیحات(درباره رویداد)" toolbar={EditorToolbar} />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="نام نمایشی در آدرس رویداد (درون سایت)"
                                colon={false}>
                                {getFieldDecorator('slug', {
                                    initialValue: this.props.initialData.slug,
                                    rules: [{
                                        required: true, message: 'پر کردن این فیلد ضروری است',
                                    }],
                                })(
                                    <Input />
                                )}
                                <Tooltip title="توجه داشته باشید ویرایش این فیلد در SEO تاثیر گذار است لذا در هنگام افزودن و ویرایش دقت لازم را داشته باشید .">
                                    <span style={{ color: 'green' }}> *نکته!</span>
                                </Tooltip>
                            </FormItem>


                            <FormItem
                                {...formItemLayout}
                                label="عنوان متا"
                                colon={false}>
                                {getFieldDecorator('meta_title', {
                                    initialValue: this.props.initialData.meta_title,
                                    rules: [
                                        {
                                            required: true, message: 'عنوان متا را اجباری است!'
                                        }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="توضیحات متا"
                                colon={false}>
                                {getFieldDecorator('meta_description', {
                                    initialValue: this.props.initialData.meta_description,
                                    rules: [
                                        {
                                            required: true, message: 'توضیحات متا اجباری است.'
                                        }
                                    ],
                                })(
                                    <Input.TextArea />
                                )}
                            </FormItem>

                            {SitemapChangeFreqInput(this.props.initialData.sitemap_change_freq, getFieldDecorator, formItemLayout)}

                            <FormItem
                                {...formItemLayout}
                                label="اولویت نقشه سایت"
                                colon={false}>
                                {getFieldDecorator('sitemap_priority', {
                                    initialValue: this.props.initialData.sitemap_priority
                                })(
                                    <Input />
                                )}
                            </FormItem>

                        </Col>


                    </Row>
                    <FormItem>
                        <div class="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>

                            {
                                this.props.initialData.id &&
                                <Button type="secondary" onClick={() => history.item.push(`/history/event/${this.props.initialData.id}`)}>تاریخچه تغییرات</Button>
                            }
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}

EventForm.defaultProps = {
    initialData: {}
}

export default Form.create()(EventForm);


// WEBPACK FOOTER //
// ./src/containers/Events/form.js